import { Tenant, Scholarship } from '../types';

// Use local images from `src/assets/images` for unit heroes
import smpImg from '../src/assets/images/smp-img.webp';
import smkImg from '../src/assets/images/smk-img.webp';
import pondokImg from '../src/assets/images/pondok-img.webp';

export const tenants: Tenant[] = [
  {
    id: '1',
    name: "SMP IT Mathla'un Nawakartika",
    slug: 'smp',
    type: 'SCHOOL',
    description: 'Membangun generasi Qurani yang cerdas, berkarakter, dan berwawasan global.',
    principal: 'Hayatu Zakiyah, S.Pd',
    heroImage: smpImg,
  },
  {
    id: '2',
    name: "SMK Mathla'un Nawakartika",
    slug: 'smk',
    type: 'SCHOOL',
    description: 'Mencetak tenaga ahli profesional yang siap kerja, santun, dan mandiri.',
    principal: 'Utoh Mashuri, S.Pd',
    heroImage: smkImg,
  },
  {
    id: '3',
    name: 'Pondok Pesantren',
    slug: 'ponpes',
    type: 'ISLAMIC_BOARDING_SCHOOL',
    description: 'Pusat pendalaman ilmu agama dengan manhaj Ahlussunnah wal Jamaah.',
    principal: 'Umi. Nurdinah, S.Pd.I.,MM',
    heroImage: pondokImg,
  },
];

export const scholarships: Scholarship[] = [
  {
    id: '1',
    title: 'Beasiswa Tahfidz Quran',
    description: 'Beasiswa penuh bagi siswa yang memiliki hafalan minimal 5 Juz.',
    requirements: ['Hafal 5 Juz Mutqin', 'Lulus Tes Tulis', 'Surat Rekomendasi'],
    deadline: '2024-03-01',
    type: 'TAHFIDZ',
  },
  {
    id: '2',
    title: 'Beasiswa Prestasi Akademik',
    description: 'Potongan biaya masuk 50% untuk ranking 1-3 di sekolah asal.',
    requirements: ['Rapor semester 1-5', 'Sertifikat Prestasi', 'Lulus Tes Potensi Akademik'],
    deadline: '2024-02-15',
    type: 'ACADEMIC',
  },
  {
    id: '3',
    title: 'Beasiswa Yatim & Dhuafa',
    description: 'Bantuan pendidikan bagi siswa yatim atau kurang mampu.',
    requirements: [
      'Surat Keterangan Tidak Mampu',
      'Surat Kematian Ayah (Yatim)',
      'KK & KTP Orang Tua',
    ],
    deadline: '2024-04-01',
    type: 'NEED_BASED',
  },
];
